module.exports = __webpack_public_path__ + "img/f_04.41d59a8.png";